import AuthLayout from '../components/Layout/auth-layout'
import Login from '../pages/Auth/Login'
import ResetPassword from '../pages/Auth/ResetPassword'
import CreatePassword from '../pages/Auth/CreatePassword'
import ResetPasswordMessage from '../pages/Auth/ResetPasswordMessage'
import { authLoader } from './authLoader'
import PasswordChanged from '@/pages/Auth/PasswordChanged'

export const authRoutes = [
  {
    element: <AuthLayout />,
    loader: authLoader,
    children: [
      {
        path: 'auth/login',
        element: <Login />,
      },
      {
        path: 'auth/reset-password',
        element: <ResetPassword />,
      },
      {
        path: 'auth/create-password',
        element: <CreatePassword />,
      },
      {
        path: 'auth/reset-message',
        element: <ResetPasswordMessage />,
      },
      {
        path: '/auth/password-changed',
        element: <PasswordChanged />,
      },
    ],
  },
]
